import {Component, OnInit} from '@angular/core';
import {TimetableService} from "../../shared/services/timetable.service";

@Component({
    selector: 'app-timetable',
    templateUrl: './timetable.component.html',
    styleUrls: ['./timetable.component.scss'],
    providers: [TimetableService]
})
export class TimetableComponent implements OnInit {

    private service: TimetableService;
    public timetable;
    public page: number = 1;
    public totalPage: number = 1;

    constructor(service: TimetableService) {
        this.service = service;
    }

    ngOnInit() {
        this.getTimetable();
    }

    getTimetable() {

        this.service.getTimetableApi(this.page).subscribe(v => {
            let parse = JSON.parse(v['_body']);
            this.timetable = parse.result;
            this.page = parse.page;
            this.totalPage = parse.totalPage;

            // if (this.page > 1 && !parse.result){
            //     --this.page;
            //     this.getTimetable();
            // }

        });
    }

    check() {

    }

    onRemove(slug) {

        console.log('remo' + slug);
        this.service.removeTimetable(slug).subscribe(v => {
            console.log(v);

            this.getTimetable();

        }, error1 => {
            console.log(error1);
        });

    }

    changePage(page) {
        //ToDo: zmien adres ?
        console.log("ChangePageTimetable");
        console.log(page);
        this.page = page;
        this.getTimetable();
    }

}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/timetable/timetable.component.ts